import type {BlockingGateId} from "@/src/modules/core/lib/compliance-gate-priority";
import type {ReconcileOwner} from "@/src/modules/core/store/blocking-gate";

type ShouldShowGateReconcileOverlayInput = {
  isVisible: boolean;
  isActive: boolean;
  reconciling: boolean;
  ownerCounts: Partial<Record<ReconcileOwner, number>>;
};

/** Gate-owned reconcile beats, or a system reconcile while this gate is active. */
export function shouldShowGateReconcileOverlay(
  gateId: BlockingGateId,
  {isVisible, isActive, reconciling, ownerCounts}: ShouldShowGateReconcileOverlayInput,
): boolean {
  if (!isVisible || !reconciling) {
    return false;
  }
  if ((ownerCounts[gateId] ?? 0) > 0) {
    return true;
  }
  return isActive && (ownerCounts.system ?? 0) > 0;
}
